import { createSlice } from '@reduxjs/toolkit';
import ASYNC_STATE from '../../../constants/AsyncState';
import { byId } from '../../../helper/byKey';
import { getErrorMsg } from '../../../helper/errorMessages';
import paginateReducer from '../../../helper/reduxPaginationHelper';
import { fetchBusinessUnitDetails, fetchBusinessUnits } from './businessUnitsThunks';

const asyncState = {
  fetch: {
    status: ASYNC_STATE.IDLE,
    errorMessage: null,
  },
  fetchBusinessUnitDetails: {
    status: ASYNC_STATE.IDLE,
    errorMessage: null,
  },
};

const initialState = {
  ...asyncState,
  businessUnits: {},
  selectedBusinessUnitId: undefined,
};

const businessUnitsSlice = createSlice({
  name: 'businessUnits',
  initialState,
  reducers: {
    businessUnitSelected: (state, action) => {
      const { businessUnitId } = action.payload;
      state.selectedBusinessUnitId = businessUnitId;
    },
    businessUnitSelectionReset: (state) => {
      state.selectedBusinessUnitId = undefined;
    },
  },
  extraReducers: {
    [fetchBusinessUnits.pending]: (state) => {
      state.fetch.status = ASYNC_STATE.LOADING;
    },
    [fetchBusinessUnits.fulfilled]: paginateReducer(
      (state) => state.fetch,
      (state, action) => {
        const { data } = action.payload;
        state.fetch.status = ASYNC_STATE.SUCCEEDED;
        state.businessUnits = { ...byId(data) };
      },
    ),
    [fetchBusinessUnits.rejected]: (state, action) => {
      const { error } = action.error;
      state.fetch.status = ASYNC_STATE.FAILED;
      state.fetch.error = error;
      state.fetch.errorMessage = getErrorMsg('default');
    },
    [fetchBusinessUnitDetails.pending]: (state) => {
      state.fetchBusinessUnitDetails.status = ASYNC_STATE.LOADING;
    },
    [fetchBusinessUnitDetails.fulfilled]: (state, action) => {
      const { businessUnit } = action.payload;
      const { id } = businessUnit;
      state.fetchBusinessUnitDetails.status = ASYNC_STATE.SUCCEEDED;
      state.selectedBusinessUnitId = id;
      state.businessUnits[id] = businessUnit;
    },
    [fetchBusinessUnitDetails.rejected]: (state, action) => {
      const { error } = action.error;
      state.fetchBusinessUnitDetails.status = ASYNC_STATE.FAILED;
      state.fetchBusinessUnitDetails.error = error;
      state.fetchBusinessUnitDetails.errorMessage = getErrorMsg('default');
    },
  },
});

export const { businessUnitSelected, businessUnitSelectionReset } = businessUnitsSlice.actions;

export default businessUnitsSlice.reducer;
